"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsLeasingJourneyThemeConstraint = void 0;
exports.isLeasingJourneyTheme = isLeasingJourneyTheme;
const class_validator_1 = require("class-validator");
const HEX_COLOR_PATTERN = /^#[0-9a-f]{3}(?:[0-9a-f]{3})?(?:[0-9a-f]{2})?$/i;
const MAX_THEME_BYTES = 4096;
const COLOR_KEYS = new Set([
    'primary',
    'secondary',
    'tertiary',
    'text',
    'background',
    'header',
    'link',
]);
const ACTION_KEYS = new Set(['primary', 'secondary', 'tertiary']);
function hasOnlyKeys(value, allowedKeys) {
    return Object.keys(value).every((key) => allowedKeys.has(key));
}
function hasValidColors(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    const colors = value;
    if (!hasOnlyKeys(colors, new Set([...COLOR_KEYS, 'actions'])))
        return false;
    const colorEntries = Object.entries(colors).filter(([key]) => key !== 'actions');
    if (!colorEntries.every(([, color]) => typeof color === 'string' && HEX_COLOR_PATTERN.test(color))) {
        return false;
    }
    if (colors.actions !== undefined) {
        if (!colors.actions || typeof colors.actions !== 'object' || Array.isArray(colors.actions)) {
            return false;
        }
        const actions = colors.actions;
        if (!hasOnlyKeys(actions, ACTION_KEYS))
            return false;
        if (!Object.values(actions).every((color) => typeof color === 'string' && HEX_COLOR_PATTERN.test(color))) {
            return false;
        }
    }
    return (colorEntries.length > 0 || Object.keys(colors.actions ?? {}).length > 0);
}
function isLeasingJourneyTheme(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    try {
        if (JSON.stringify(value).length > MAX_THEME_BYTES)
            return false;
    }
    catch {
        return false;
    }
    const theme = value;
    return (hasOnlyKeys(theme, new Set(['version', 'colors'])) &&
        theme.version === 1 &&
        hasValidColors(theme.colors));
}
let IsLeasingJourneyThemeConstraint = (() => {
    let _classDecorators = [(0, class_validator_1.ValidatorConstraint)({ name: 'isLeasingJourneyTheme', async: false })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var IsLeasingJourneyThemeConstraint = _classThis = class {
        validate(value) {
            return isLeasingJourneyTheme(value);
        }
        defaultMessage(_args) {
            return 'theme must be a valid version 1 Leasing Journey theme using hex color values';
        }
    };
    __setFunctionName(_classThis, "IsLeasingJourneyThemeConstraint");
    (() => {
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        IsLeasingJourneyThemeConstraint = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return IsLeasingJourneyThemeConstraint = _classThis;
})();
exports.IsLeasingJourneyThemeConstraint = IsLeasingJourneyThemeConstraint;
